
export default {
    props:[
        'name',
        'address',
        'directions',
        'phone',
        'mapFeatures',
        'url',
        'type'
    ],
    created(){
        console.log('InfoContent Created()',this.props);
    }
}
